/**
 * created by hezq on 2019年03月28日
 *
 * description： ajax封装请求
 *
 */
import Qs from 'qs';
import Cookies from 'js-cookie';
import utils from 'libs/utils';
const Base64 = require('js-base64').Base64;

const config = require('./config.js');

// 网络队列
let netQuene = {};

let http = {
	ajax(options, success, error) {
		// 可以只传字符串，默认作为url处理
		if (typeof options === 'string') {
			options = {
				url: options
			};
		}

		// 默认get请求
		options.type = options.type || 'GET';
		// 如果options里没传data，默认{}
		options.data = options.data || {};
		// 网络队列名称
		const netName = `${options.url}_${options.type}`;
		// 转换数据为String类型
		const dataStr = JSON.stringify(options.data || {});
		let defaultConfig = {
			dataType: options.dataType || 'json',
			type: options.type,
			url: options.url,
			cache: false,
			beforeSend(xhr) {
				// 设置跨域凭证
				xhr.withCredentials = true;
				// 设置Authorization
				xhr.setRequestHeader('Authorization', Cookies.get(config.PLAT + config.DOMAIN + '.access_token', {
					domain: config.DOMAIN
				}) || '');
			},
			success(res) {
				// 成功删除指定网络队列
				if(netQuene[netName] instanceof Array) {
					netQuene[netName].filter(item =>  item.dataStr === dataStr).forEach(item => {
						netQuene[netName].remove(item);
					});
					// 判断数组是否还有值
					if(netQuene[netName].length === 0) {
						delete netQuene[netName];
					}
				}

				// 根据code统一处理
				if (res.code === 400) {
					utils.alert({
						message: res.msg || config.MSG_SERVER_ERROR,
						type: 'error',
						duration: 3000
					});

					error && error();

				} else if (res.code === 401) {
					utils.alert({
						message: config.MSG_NO_LOGIN,
						type: 'error',
						duration: 3000
					});

					utils.loginOut();
				} else if (res.code === 403) {
					utils.alert({
						message: config.MSG_NO_AUTH,
						type: 'error',
						duration: 1000
					});

					setTimeout(() => {
						utils.href('noauth/index.html',{url:Base64.encode(options.url)});
					}, 1000);
				} else {
					success && success(res.data || {});
				}

			},
			error(xhr, status, errorThrown) {
				// 失败删除指定网络队列
				if(netQuene[netName] instanceof Array) {
					netQuene[netName].filter(item =>  item.dataStr === dataStr).forEach(item => {
						netQuene[netName].remove(item);
					});
					// 判断数组是否还有值
					if(netQuene[netName].length === 0) {
						delete netQuene[netName];
					}
				}

				if(status !== 'abort') {
					utils.alert({
						message: '服务休息中，请稍后再试！',
						type: 'error',
						duration: 5000
					});

					error && error();
				}
			}
		};

		if(options.type==='GET' || options.type==='DELETE'){
			defaultConfig.contentType = 'application/x-www-form-urlencoded;charset=utf-8;';
			options.data.ssid = config.SSID;
			options.data.subsystem = config.SUB_SYSTEM;
			options.data = {...options.data,...options.params};
			defaultConfig.url += '?' + Qs.stringify(options.data);
		}else{
			defaultConfig.contentType = 'application/json;charset=utf-8;';
			options.params = options.params || {};
			options.params.ssid = config.SSID;
			options.params.subsystem = config.SUB_SYSTEM;
			options.data.subsystem = config.SUB_SYSTEM;
			if(options.params){
				if(defaultConfig.url.indexOf('?') == -1){
					defaultConfig.url += '?' + Qs.stringify(options.params);
				}else{
					defaultConfig.url += '&' + Qs.stringify(options.params);
				}
			}
			defaultConfig.data = JSON.stringify(options.data);
		}

		jQuery.support.cors = true;

		let ajax = $.ajax(defaultConfig);

		// 判断是否相同请求方式地址以及请求参数是否相同
		if(netQuene[netName] instanceof Array && netQuene[netName].some(item => item.dataStr === dataStr)) {
			// 打断上一个接口
			netQuene[netName].filter(item =>  item.dataStr === dataStr).forEach(element => {
				element.abort();
			});
		}
		// 当前接口加入队列
		if(netQuene[netName] instanceof Array ) {
			netQuene[netName].push({...ajax, dataStr: dataStr});
		} else {
			netQuene[netName] = [{...ajax, dataStr: dataStr}];
		}
	},


	// jsonp请求
	jsonp(options, success, error) {
		// 可以只传字符串，默认作为url处理
		if (typeof options === 'string') {
			options = {
				url: options
			};
		}
		// 如果options里没传data，默认{}
		options.data = options.data || {};
		// 默认带上参数ssid，接口需要
		options.data.ssid = config.SSID;
		options.data.subsystem = config.SUB_SYSTEM;

		// 默认GET请求
		options.type = 'GET';
		// 解决在ie下请求缓存的问题 FIXME:cache设置为false默认带时间戳
		// options.data._ = new Date().getTime();
		// 网络队列名称
		const netName = `${options.url}_${options.type}`;
		// 转换数据为String类型
		const dataStr = JSON.stringify(options.data || {});
		// ajax配置项，详细参考：http://www.w3school.com.cn/jquery/ajax_ajax.asp
		let defaultConfig = {
			dataType: 'jsonp',
			jsonp: 'jsoncallback',
			type: options.type,
			url: options.url,
			cache: false,
			data: options.data,
			beforeSend(xhr) {
				// 设置跨域凭证
				xhr.withCredentials = true;
				// 设置Authorization
				xhr.setRequestHeader('Authorization', Cookies.get(config.PLAT + config.DOMAIN + '.access_token', {
					domain: config.DOMAIN
				}) || '');
			},
			success(res) {
				// 成功删除指定网络队列
				if(netQuene[netName] instanceof Array) {
					netQuene[netName].filter(item =>  item.dataStr === dataStr).forEach(item => {
						netQuene[netName].remove(item);
					});
					// 判断数组是否还有值
					if(netQuene[netName].length === 0) {
						delete netQuene[netName];
					}
				}
				// 根据code统一处理
				if (res.code === 1) {
					utils.alert({
						message: res.message || config.MSG_SERVER_ERROR,
						type: 'error',
						duration: 3000
					});
					error && error();
				} else {
					success && success(res.data || {});
				}
			},
			error(xhr, status, errorThrown) {
				// 失败删除指定网络队列
				if(netQuene[netName] instanceof Array) {
					netQuene[netName].filter(item =>  item.dataStr === dataStr).forEach(item => {
						netQuene[netName].remove(item);
					});
					// 判断数组是否还有值
					if(netQuene[netName].length === 0) {
						delete netQuene[netName];
					}
				}

				if(status !== 'abort') {
					utils.alert({
						message: '服务休息中，请稍后再试！',
						type: 'error',
						duration: 5000
					});

					error && error();
				}
			}
		};

		let ajax = $.ajax(defaultConfig);

		// 判断是否相同请求方式地址以及请求参数是否相同
		if(netQuene[netName] instanceof Array && netQuene[netName].some(item => item.dataStr === dataStr)) {
			// 打断上一个接口
			netQuene[netName].filter(item =>  item.dataStr === dataStr).forEach(element => {
				element.abort();
			});
		}
		// 当前接口加入队列
		if(netQuene[netName] instanceof Array ) {
			netQuene[netName].push({...ajax, dataStr: dataStr});
		} else {
			netQuene[netName] = [{...ajax, dataStr: dataStr}];
		}
	},

	/**
	 * description: 打断请求
	 * @param {String} url 请求地址
	 * @param {String} [type= 'GET'] 请求方式
	 * @param {Object} data 请求参数
	 *
	 * created by zhouzt on 2019-11-05
	 *
	 */
	abort(url, type = 'GET', data) {
		// 网络队列名称
		const netName = `${url}_${type}`;

		// 判断队列是否为数组
		if(netQuene[netName] instanceof Array) {
			if(data) {
				// 转换数据为String类型
				const dataStr = JSON.stringify(data || {});

				// 打断指定请求
				netQuene[netName].filter(item =>  item.dataStr === dataStr).forEach(element => {
					element.abort();
				});
			} else {
				netQuene[netName].forEach(item => {
					item.abort();
				});
			}
		}
	},

	/**
	 * description: 打断所有接口（用于切换页面）
	 *
	 * created by zhouzt on 2019-11-06
	 *
	 */
	abortAll() {
		// 遍历对象属性
		for(let netObj in netQuene) {
			if(netQuene[netObj] instanceof Array) {
				netQuene[netObj].forEach(item => {
					item.abort();
				});
			}
		}
	}
};

export default http;


// WEBPACK FOOTER //
// ./src/libs/http.js